import { render, staticRenderFns } from "./EmailFieldValidator.vue?vue&type=template&id=9637ba9e&"
import script from "./EmailFieldValidator.vue?vue&type=script&lang=ts&"
export * from "./EmailFieldValidator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports